<latch-floor-group-list-edit
  [elevatorName]="data.elevatorName"
  [elevatorDetails]="data.elevatorDetails"
  [selectedFloorGroupUUID]="data.selectedFloorGroupUUID"
  [showWarningMessage]="data.showWarningMessage"
  [defaultFloorGroupSelectMode]="data.defaultFloorGroupSelectMode"
  (cancel)="onBackClick()"
  (save)="onDoneClick($event)">
</latch-floor-group-list-edit>
